const initialState ={
    data:null,
    status:"idle",
    error:null,
}

const contactusReducer =(state=initialState, action)=>{
    switch(action.type){
        case "SET_CONTACTUS_DATA":
            return {...state, data:action.payload};
        default:
            return state;

    }

}

export default contactusReducer;